// extracted by mini-css-extract-plugin
module.exports = {"eo8nzhl":"eo8nzhl","t1ya3db2":"t1ya3db2"};